module.exports = __webpack_public_path__ + "static/media/package.4927aa49.svg";